import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { Params } from "@/types";

const endpoint = (scheduleId: number | null) => ({
  services: `/schedules/${scheduleId}/services`,
});

export const fetchScheduleServices = createAsyncThunk(
  "scheduleServices/fetchServices",
  async (
    { scheduleId, params }: { scheduleId: number | null; params?: Params },
    thunkAPI,
  ) => {
    try {
      const response = await axiosInstance.get(endpoint(scheduleId).services, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const errorMessage = error?.response?.data as {
          message?: string;
        };
        return thunkAPI.rejectWithValue({
          error: errorMessage?.message || error.message,
        });
      } else {
        return thunkAPI.rejectWithValue({
          error: "Erro desconhecido ao buscar serviços do agendamento.",
        });
      }
    }
  },
);

export const createScheduleService = createAsyncThunk(
  "scheduleServices/createService",
  async (
    {
      scheduleId,
      serviceData,
    }: { scheduleId: number | null; serviceData: any },
    thunkAPI,
  ) => {
    try {
      const response = await axiosInstance.post(
        endpoint(scheduleId).services,
        serviceData,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const errorMessage = error?.response?.data as {
          message?: string;
        };
        return thunkAPI.rejectWithValue({
          error: errorMessage?.message || error.message,
        });
      } else {
        return thunkAPI.rejectWithValue({
          error: "Erro desconhecido ao criar serviço do agendamento.",
        });
      }
    }
  },
);

export const updateScheduleService = createAsyncThunk(
  "scheduleServices/updateService",
  async (
    {
      scheduleId,
      serviceId,
      data,
    }: { scheduleId: number | null; serviceId: number | string; data: any },
    thunkAPI,
  ) => {
    try {
      const response = await axiosInstance.put(
        `${endpoint(scheduleId).services}/${serviceId}`,
        data,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const errorMessage = error?.response?.data as {
          message?: string;
        };
        return thunkAPI.rejectWithValue({
          error: errorMessage?.message || error.message,
        });
      } else {
        return thunkAPI.rejectWithValue({
          error: "Erro desconhecido ao atualizar serviço do agendamento.",
        });
      }
    }
  },
);

export const deleteScheduleService = createAsyncThunk(
  "scheduleServices/deleteService",
  async (
    {
      scheduleId,
      serviceId,
    }: { scheduleId: number | null; serviceId: number | null },
    thunkAPI,
  ) => {
    try {
      const response = await axiosInstance.delete(
        `${endpoint(scheduleId).services}/${serviceId}`,
      );
      return { ...response.data, serviceId };
    } catch (error) {
      if (isAxiosError(error)) {
        const errorMessage = error?.response?.data as {
          message?: string;
        };
        return thunkAPI.rejectWithValue({
          error: errorMessage?.message || error.message,
        });
      } else {
        return thunkAPI.rejectWithValue({
          error: "Erro desconhecido ao excluir serviço do agendamento.",
        });
      }
    }
  },
);
